import type { TripReportStatus } from '@this/domain/trip_report/trip_report';
import { STATUS_NAMES } from '@this/domain/trip_report/trip_report';

// 【出張者情報・旅程一覧】の報告番号検索で返る、旅程に紐づかない出張報告
export type TripReportWithoutTripResponseArgs = {
  id: number;
  status: TripReportStatus;
  applicant_name: string | null;
  total_price: number;
};

export type TripReportWithoutTripArgs = {
  id: number;
  status: TripReportStatus;
  applicantName: string | null;
  totalPrice: number;
};

export const convertTripReportWithoutTripResponseToArgs = (
  response: TripReportWithoutTripResponseArgs
): TripReportWithoutTripArgs => ({
  id: response.id,
  status: response.status,
  applicantName: response.applicant_name,
  totalPrice: response.total_price
});

export default class TripReportWithoutTrip {
  id: number;
  status: TripReportStatus;
  applicantName: string | null;
  totalPrice: number;

  constructor(args: TripReportWithoutTripArgs) {
    this.id = args.id;
    this.status = args.status;
    this.applicantName = args.applicantName;
    this.totalPrice = args.totalPrice;
  }

  statusName(): string {
    return STATUS_NAMES[this.status];
  }
}
